// import React, { useEffect, useState } from 'react'
// import { Button, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap'
// import {
//   BsList,
//   BsPlus,
//   BsPerson,
//   BsGrid,
//   BsPeople,
//   BsHourglassSplit,
//   BsPersonPlus,
//   BsCalendarEvent,
//   BsXCircle,
//   BsPlusCircle,
//   BsFileEarmarkSpreadsheet,
// } from 'react-icons/bs'
// import { CiLogout } from 'react-icons/ci'
// import '../TmsStyles/TmsSidebar.css'
// import AddTrainingModal from './AddTrainingModal'
// import AddUserModal from './AddUserModal'
// import { useNavigate } from 'react-router-dom'
// import axios from 'axios'

// const TmsSidebar = () => {
//   const [collapsed, setCollapsed] = useState(false)
//   const [isTrainingModalOpen, setTrainingModalOpen] = useState(false)
//   const [isAddUserModalOpen, setAddUserModalOpen] = useState(false)
//   const navigate = useNavigate()

//   const [links, setLink] = useState([
//     { href: '/tmsdashboard', icon: <BsGrid size={20} />, label: 'Dashboard' },
//     { href: '/training', icon: <BsPlus size={20} />, label: 'Training' },
//     {
//       href: '/pendingtraining',
//       icon: <BsHourglassSplit size={20} />,
//       label: 'Pending Training',
//     },
//     {
//       href: '/upcomingtraining',
//       icon: <BsCalendarEvent size={20} />,
//       label: 'Upcoming Training',
//     },
//     {
//       href: '/declinedtraining',
//       icon: <BsXCircle size={20} />,
//       label: 'Declined Training',
//     },
//     {
//       href: '/participants',
//       icon: <BsPeople size={20} />,
//       label: 'Participants',
//     },
//     {
//       href: '/addparticipants',
//       icon: <BsPersonPlus size={20} />,
//       label: 'Add Participants',
//     },
//     {
//       href: '/createassessment',
//       icon: <BsPlusCircle size={20} />,
//       label: 'Create Assessment',
//     },
//     {
//       href: '/result',
//       icon: <BsFileEarmarkSpreadsheet size={20} />,
//       label: 'Result',
//     },
//     { href: '/log', icon: <CiLogout size={20} />, label: 'Logout' },
//   ])

//   const toggleSidebar = () => {
//     setCollapsed(!collapsed)
//   }
//   const URL = 'https://kaasbackend.vetrinahealthcare.com/'
//   const token = localStorage.getItem('jwttoken')

//   const allowedLinks = ['/results', '/log']

//   useEffect(() => {
//     const role = localStorage.getItem('role')
//     if (role === 'Client' || role === 'Trainer') {
//       setLink(links.filter((link) => allowedLinks.includes(link.href)))
//     }
//   }, [])

//   const logout = () => {
//     axios
//       .post(
//         `${URL}auth/logout/`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       )
//       .then(() => {
//         localStorage.removeItem('jwttoken')
//         navigate('/Log')
//       })
//       .catch((reason) => {
//         alert(reason)
//         localStorage.removeItem('jwttoken')
//         navigate('/Log')
//       })
//   }

//   return (
//     <div
//       style={{ display: 'flex', height: '100vh', backgroundColor: '#F8F9FA' }}
//     >
//       <aside
//         id='sidebar'
//         className={`bg-light ${collapsed ? 'collapsed' : ''}`}
//         style={{
//           backgroundColor: '#ffffff',
//           height: '105vh',
//           width: collapsed ? '60px' : '250px',
//           transition: 'width 0.3s ease',
//           boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)',
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'column',
//           padding: '10px 0',
//           margin: 0,
//         }}
//       >
//         <div
//           className='d-flex justify-content-between align-items-center px-3 py-2'
//           style={{ borderBottom: '1px solid #ddd' }}
//         >
//           <h5
//             className='text-dark m-0'
//             style={{ fontSize: '1.2rem', fontWeight: 'bold' }}
//           >
//             {!collapsed && ''}
//           </h5>
//           <button
//             onClick={toggleSidebar}
//             className='btn btn-light'
//             style={{ padding: '5px 8px', borderRadius: '50%' }}
//           >
//             <BsList size={20} />
//           </button>
//         </div>

//         <Nav defaultActiveKey='/home' className='flex-column mt-3' style={{}}>
//           {!collapsed && (
//             <div className='mb-3 px-2'>
//               <Button
//                 variant='primary'
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   marginBottom: '10px',
//                   fontWeight: '500',
//                   fontSize: '0.95rem',
//                   padding: '10px',
//                 }}
//                 onClick={() => setTrainingModalOpen(true)}
//                 disabled={localStorage.getItem('role') !== 'Admin'}
//               >
//                 <BsPlus className='me-2' /> Add Training
//               </Button>
//               <AddTrainingModal
//                 isOpen={isTrainingModalOpen}
//                 onClose={() => setTrainingModalOpen(false)}
//               />

//               <Button
//                 variant='secondary'
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontWeight: '500',
//                   fontSize: '0.95rem',
//                   padding: '10px',
//                 }}
//                 onClick={() => setAddUserModalOpen(true)}
//                 disabled={localStorage.getItem('role') !== 'Admin'}
//               >
//                 <BsPerson className='me-2' /> Add User
//               </Button>
//               <AddUserModal
//                 show={isAddUserModalOpen}
//                 handleClose={() => setAddUserModalOpen(false)}
//               />
//             </div>
//           )}

//           {links.map((item, index) => (
//             <Nav.Item key={index} className='tnav-item'>
//               <OverlayTrigger
//                 placement='right'
//                 overlay={<Tooltip>{item.label}</Tooltip>}
//               >
//                 <Nav.Link
//                   href={item.href}
//                   className='d-flex align-items-center'
//                   style={{
//                     color: '#333',
//                     padding: '8px 15px',
//                     borderRadius: '5px',
//                     justifyContent: collapsed ? 'center' : 'flex-start', // Center icons when collapsed
//                     // marginRight: "100px"
//                   }}
//                 >
//                   {item.icon}
//                   {!collapsed && (
//                     <span
//                       className='ms-3'
//                       style={{ fontSize: '0.95rem', fontWeight: '500' }}
//                     >
//                       {item.label}
//                     </span>
//                   )}
//                 </Nav.Link>
//               </OverlayTrigger>
//             </Nav.Item>
//           ))}
//         </Nav>
//       </aside>
//     </div>
//   )
// }

// export default TmsSidebar

import React, { useEffect, useState } from 'react';
import { Button, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  BsList,
  BsPlus,
  BsPerson,
  BsGrid,
  BsPeople,
  BsHourglassSplit,
  BsPersonPlus,
  BsCalendarEvent,
  BsXCircle,
  BsPlusCircle,
  BsFileEarmarkSpreadsheet,
} from 'react-icons/bs';
import { CiLogout } from 'react-icons/ci';
import { useLocation } from 'react-router-dom';
import AddTrainingModal from './AddTrainingModal';
import AddUserModal from './AddUserModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const TmsSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isTrainingModalOpen, setTrainingModalOpen] = useState(false);
  const [isAddUserModalOpen, setAddUserModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [links, setLink] = useState([
    { href: '/tmsdashboard', icon: <BsGrid size={20} />, label: 'Dashboard' },
    { href: '/training', icon: <BsPlus size={20} />, label: 'Training' },
    {
      href: '/pendingtraining',
      icon: <BsHourglassSplit size={20} />,
      label: 'Pending Training',
    },
    {
      href: '/upcomingtraining',
      icon: <BsCalendarEvent size={20} />,
      label: 'Upcoming Training',
    },
    {
      href: '/declinedtraining',
      icon: <BsXCircle size={20} />,
      label: 'Declined Training',
    },
    {
      href: '/participants',
      icon: <BsPeople size={20} />,
      label: 'Participants',
    },
    {
      href: '/addparticipants',
      icon: <BsPersonPlus size={20} />,
      label: 'Add Participants',
    },
    {
      href: '/createassessment',
      icon: <BsPlusCircle size={20} />,
      label: 'Create Assessment',
    },
    {
      href: '/result',
      icon: <BsFileEarmarkSpreadsheet size={20} />,
      label: 'Result',
    },
    { href: '/log', icon: <CiLogout size={20} />, label: 'Logout' },
  ]);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const URL = 'https://kaasbackend.vetrinahealthcare.com/';
  const token = localStorage.getItem('jwttoken');
  const allowedLinks = ['/results', '/log'];

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role === 'Client' || role === 'Trainer') {
      setLink(links.filter((link) => allowedLinks.includes(link.href)));
    }
  }, []);

  const logout = () => {
    axios
      .post(
        `${URL}auth/logout/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        localStorage.removeItem('jwttoken');
        navigate('/Log');
      })
      .catch((reason) => {
        alert(reason);
        localStorage.removeItem('jwttoken');
        navigate('/Log');
      });
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* Fixed Sidebar */}
      <aside
        style={{
          background: '#f97316',
          height: '100vh',
          width: collapsed ? '70px' : '250px',
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)',
          transition: 'width 0.3s ease',
        }}
      >
        {/* Header */}
       <div
  style={{
    position: 'relative',
    padding: '12px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
    minHeight: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  {/* Centered Title */}
 {!collapsed && (
    <>
      <button
        onClick={() => navigate('/lmsadmindashboard')}
        style={{
          position: 'absolute',
          left: '12px',
          background: 'rgba(255,255,255,0.1)',
          border: 'none',
          borderRadius: '50%',
          color: 'white',
          width: '36px',
          height: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        }}
        title="Back"
      >
        ←
      </button>
      <h5
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'white',
          margin: 0,
          fontSize: '1.1rem',
          fontWeight: '600',
        }}
      >
        TMS 
      </h5>
    </>
  )}

 
  <button
    onClick={toggleSidebar}
    style={{
      position: 'absolute',
      right: '12px',
      background: 'rgba(255,255,255,0.1)',
      border: 'none',
      borderRadius: '50%',
      color: 'white',
      width: '36px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    }}
  >
    <BsList size={20} />
  </button>
</div>


        {/* Scrollable Content */}
        <div style={{ 
          flex: 1,
          overflowY: 'auto',
          padding: '8px',
          scrollbarWidth: 'thin',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': {
            width: '4px'
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255,255,255,0.2)',
            borderRadius: '2px'
          }
        }}>
          {/* Buttons */}
          {!collapsed && (
            <div style={{ marginBottom: '12px' }}>
              <Button
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  marginBottom: '10px',
                  background: '#d9069a',
                  border: 'none',
                  borderRadius: '8px',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                onClick={() => setTrainingModalOpen(true)}
                disabled={localStorage.getItem('role') !== 'Admin'}
              >
                <BsPlus style={{ marginRight: '8px' }} />
                Add Training
              </Button>

              <Button
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  background: '#d9069a',
                  border: 'none',
                  borderRadius: '8px',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                onClick={() => setAddUserModalOpen(true)}
                disabled={localStorage.getItem('role') !== 'Admin'}
              >
                <BsPerson style={{ marginRight: '8px' }} />
                Add User
              </Button>
            </div>
          )}

          {/* Menu Links */}
          <Nav style={{ display: 'flex', flexDirection: 'column' }}>
            {links.map((item, index) => (
              <Nav.Item key={index} style={{ marginBottom: '4px' }}>
                <OverlayTrigger placement="right" overlay={<Tooltip>{item.label}</Tooltip>}>
                  <Nav.Link
                    href={item.href}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 12px',
                      borderRadius: '8px',
                      color: location.pathname === item.href ? '#f97316' : 'white',
                      background: location.pathname === item.href ? 'white' : 'transparent',
                      textDecoration: 'none',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        background: location.pathname === item.href ? 'white' : 'rgba(255,255,255,0.1)'
                      }
                    }}
                    onClick={(e) => {
                      if (item.href === '/log') {
                        e.preventDefault();
                        logout();
                      }
                    }}
                  >
                    <span style={{ 
                      display: 'flex',
                      color: location.pathname === item.href ? '#f97316' : 'white'
                    }}>
                      {item.icon}
                    </span>
                    {!collapsed && (
                      <span style={{ 
                        marginLeft: '12px', 
                        fontSize: '0.9rem',
                        fontWeight: '500'
                      }}>
                        {item.label}
                      </span>
                    )}
                  </Nav.Link>
                </OverlayTrigger>
              </Nav.Item>
            ))}
          </Nav>
        </div>
      </aside>

      {/* Main Content Area */}
      <div style={{
        marginLeft: collapsed ? '70px' : '250px',
        flex: 1,
        overflowY: 'auto',
        height: '100vh',
        transition: 'margin-left 0.3s ease'
      }}>
        {/* Your page content goes here */}
      </div>

      {/* Modals */}
      <AddTrainingModal
        isOpen={isTrainingModalOpen}
        onClose={() => setTrainingModalOpen(false)}
      />
      <AddUserModal
        show={isAddUserModalOpen}
        handleClose={() => setAddUserModalOpen(false)}
      />
    </div>
  );
};

export default TmsSidebar;